const facilities = [
  {
    id: "lakeland-main-po",
    icon: "ri-mail-line",
    name: "Lakeland Main Post Office",
    type: "USPS Passport Acceptance",
    address: "210 N Missouri Ave",
    city: "Lakeland",
    state: "FL",
    zip: "33801",
    phone: "863-802-8190",
    hours: "Mon–Fri 8:30AM–5:00PM, Sat 9:00AM–12:00PM",
    distance: "Downtown Lakeland",
    website: "https://tools.usps.com/find-location.htm",
    websiteLabel: "Schedule Appointment",
    notes: "Appointment required. Walk-ins not accepted for passport services. Bring all original documents and photocopies.",
  },
  {
    id: "lakeland-south-po",
    icon: "ri-mail-line",
    name: "Lakeland Southside Station",
    type: "USPS Passport Acceptance",
    address: "6000 S Florida Ave",
    city: "Lakeland",
    state: "FL",
    zip: "33813",
    phone: "863-644-3371",
    hours: "Mon–Fri 9:00AM–4:30PM",
    distance: "South Lakeland",
    website: "https://tools.usps.com/find-location.htm",
    websiteLabel: "Schedule Appointment",
    notes: "Appointment required. Bring completed DS-11 or DS-82 form with supporting documents.",
  },
  {
    id: "lakeland-highlands-po",
    icon: "ri-mail-line",
    name: "Lakeland Highlands Station",
    type: "USPS Passport Acceptance",
    address: "6725 S Florida Ave",
    city: "Lakeland",
    state: "FL",
    zip: "33813",
    phone: "863-619-1141",
    hours: "Mon–Fri 8:30AM–4:30PM",
    distance: "South Lakeland — Highlands area",
    website: "https://tools.usps.com/find-location.htm",
    websiteLabel: "Schedule Appointment",
    notes: "Appointment required. Smaller facility — call ahead to confirm passport services are available.",
  },
  {
    id: "polk-clerk",
    icon: "ri-government-line",
    name: "Polk County Clerk of Courts",
    type: "County Clerk Passport Acceptance",
    address: "255 N Broadway Ave",
    city: "Bartow",
    state: "FL",
    zip: "33830",
    phone: "863-534-4000",
    hours: "Mon–Fri 8:00AM–5:00PM",
    distance: "Bartow — Polk County Government Center",
    website: "https://www.polkcountyclerk.net",
    websiteLabel: "Polk County Clerk Website",
    notes: "Walk-in passport acceptance available at some times — call ahead to confirm availability and hours.",
  },
  {
    id: "winter-haven-po",
    icon: "ri-mail-line",
    name: "Winter Haven Post Office",
    type: "USPS Passport Acceptance",
    address: "111 W Central Ave",
    city: "Winter Haven",
    state: "FL",
    zip: "33880",
    phone: "863-294-3322",
    hours: "Mon–Fri 8:30AM–5:00PM",
    distance: "Winter Haven — east of Lakeland",
    website: "https://tools.usps.com/find-location.htm",
    websiteLabel: "Schedule Appointment",
    notes: "Appointment required. Serves eastern Polk County residents near Winter Haven and Lake Wales.",
  },
  {
    id: "plant-city-po",
    icon: "ri-mail-line",
    name: "Plant City Post Office",
    type: "USPS Passport Acceptance",
    address: "2501 Walden Woods Dr",
    city: "Plant City",
    state: "FL",
    zip: "33566",
    phone: "813-752-2610",
    hours: "Mon–Fri 9:00AM–4:30PM",
    distance: "Plant City — west of Lakeland via I-4",
    website: "https://tools.usps.com/find-location.htm",
    websiteLabel: "Schedule Appointment",
    notes: "Call ahead to confirm passport acceptance availability. Appointment strongly recommended.",
  },
];

export default function AcceptanceFacilitiesSection() {
  return (
    <section id="acceptance-facilities" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Passport Acceptance Clerks</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Passport Acceptance Facilities Near Lakeland
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed mb-6">
            First-time applicants and most in-person filers must visit an acceptance clerk. All locations require an appointment. This is the self-service option for those with 1–2+ months before travel.
          </p>
          <div className="bg-amber-50 border border-amber-200 rounded-lg p-5 max-w-2xl mx-auto text-left">
            <div className="flex items-start gap-3">
              <div className="w-8 h-8 flex items-center justify-center rounded-full bg-amber-100 flex-shrink-0 mt-0.5">
                <i className="ri-error-warning-line text-amber-600 text-base"></i>
              </div>
              <p className="text-gray-700 text-sm leading-relaxed">
                If you want expedited processing, sign up with{" "}
                <a href="https://fastpassportcenter.com/checkout/" className="font-bold text-[#1A365D] underline underline-offset-2 hover:text-[#F6C344] transition-colors">
                  Fast Passport Center
                </a>{" "}
                <strong>before</strong> your clerk visit. Once you apply at the clerk, your documents enter the standard route and cannot be upgraded afterward.
              </p>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-10">
          {facilities.map((f) => (
            <article key={f.id} className="bg-[#F7F8FA] border border-gray-200 rounded-lg p-6 flex flex-col hover:border-[#F6C344] transition-all duration-200">
              <div className="flex items-start gap-3 mb-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#1A365D] flex-shrink-0">
                  <i className={`${f.icon} text-[#F6C344] text-base`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="font-bold text-[#1A365D] text-sm leading-snug mb-0.5">{f.name}</h3>
                  <span className="text-xs text-gray-400 font-medium">{f.type}</span>
                </div>
              </div>
              <div className="space-y-2 flex-1">
                <div className="flex items-start gap-2 text-sm text-gray-600">
                  <i className="ri-map-pin-line text-[#F6C344] flex-shrink-0 mt-0.5 text-base"></i>
                  <span>{f.address}, {f.city}, {f.state} {f.zip}</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-gray-600">
                  <i className="ri-phone-line text-[#F6C344] flex-shrink-0 text-base"></i>
                  <a href={`tel:${f.phone.replace(/-/g,"")}`} className="hover:text-[#1A365D] transition-colors">{f.phone}</a>
                </div>
                <div className="flex items-start gap-2 text-sm text-gray-600">
                  <i className="ri-time-line text-[#F6C344] flex-shrink-0 mt-0.5 text-base"></i>
                  <span>{f.hours}</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-gray-600">
                  <i className="ri-road-map-line text-[#F6C344] flex-shrink-0 text-base"></i>
                  <span>{f.distance}</span>
                </div>
                <div className="flex items-center gap-2 text-sm">
                  <i className="ri-global-line text-[#F6C344] flex-shrink-0 text-base"></i>
                  <a href={f.website} target="_blank" rel="nofollow noopener noreferrer" className="text-[#1A365D] font-medium hover:text-[#F6C344] transition-colors underline underline-offset-2">{f.websiteLabel}</a>
                </div>
              </div>
              <div className="mt-4 pt-4 border-t border-gray-200">
                <span className="inline-flex items-center gap-1 text-xs font-semibold bg-amber-50 text-amber-700 px-2 py-0.5 rounded-full whitespace-nowrap mb-2">
                  <i className="ri-calendar-line text-xs"></i> Appointment Required
                </span>
                <p className="text-xs text-gray-400 leading-relaxed italic">{f.notes}</p>
              </div>
            </article>
          ))}
        </div>

        <div className="bg-[#1A365D] rounded-lg p-4 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-start gap-4">
            <div className="w-11 h-11 flex items-center justify-center rounded-full bg-[#F6C344] flex-shrink-0">
              <i className="ri-information-line text-[#1A365D] text-xl"></i>
            </div>
            <div>
              <p className="font-bold text-white text-base mb-1">Sign up before your clerk visit</p>
              <p className="text-white/70 text-sm leading-relaxed max-w-xl">
                Once your documents go through the standard route at the clerk, they cannot be upgraded. Sign up with Fast Passport Center <strong className="text-white">first</strong> if you need expedited processing.
              </p>
            </div>
          </div>
          <a href="https://fastpassportcenter.com/checkout/" className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-6 py-3 rounded-md transition-all whitespace-nowrap flex-shrink-0">
            Start My Passport <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}